import { render, staticRenderFns } from "./DonationChart.vue?vue&type=template&id=70525094"
import script from "./DonationChart.vue?vue&type=script&lang=js"
export * from "./DonationChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports